import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ReporteVentasArticulosMPAgrupado() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [avgPrecioPromedioBruto, setAvgPrecioPromedioBruto] = useState(0);
  const [avgCostoTotal, setAvgCostoTotal] = useState(0);
  const [avgPrecioPromedioNeto, setAvgPrecioPromedioNeto] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

  useEffect(() => {
      axios
    .get(`${URL_ARTICULOS_SURTIDOS}FechasVentaArticulosMPAgrupado/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      // Ya viene agrupado y listo desde el backend
      setComments(response.data);

        setCargando(false);
        Toast.close();

      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_MARCAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allMarcas = response.data;
          setMarcas(allMarcas);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
          .get(URL_UNIDADES_NEGOCIO, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allUnidadesNegocio = response.data;
            setUnidadesNegocio(allUnidadesNegocio);
          })
          .catch((err) => {
            console.log(err);
          })

  }, []);

  function BuscaInfo(){
    setComments([])
    setCargando(true)
     axios
    .get(`${URL_ARTICULOS_SURTIDOS}FechasVentaArticulosMPAgrupado/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      // Ya viene agrupado y listo desde el backend
      setComments(response.data);

      setCargando(false);
      setFechaModificada(false); // ✅ Regresa color azul
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
  }

console.log("hola", comments)
  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca) &&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo MP Agrupado`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ventas.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {

    const dataExcel = comments.map((a) => {
      if (
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca) &&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) 
      {
        return {
          SKU: a.SKU,
          Nombre: a.Nombre,
          Marca: a.Marca,
          Linea: a.Linea,
          Cantidad: a.Cantidad,
          EntregadoCantidad: a.EntregadoCantidad,
          PendienteEntregarCantidad: a.PendienteEntregarCantidad,
          PrecioPromedioBruto: a.PrecioPromedioBruto,
          CostoTotal: a.CostoTotal,
          PrecioPromedioNeto: a.PrecioPromedioNeto,
          MargenBruto: a.MargenBruto,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "RepVentasArticulosMPAgrup";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "RepVentasArticulosMPAgrup",
        sheetFilter: [
          "SKU",
          "Nombre",
          "Marca",
          "Linea",
          "Cantidad",
          "EntregadoCantidad",
          "PendienteEntregarCantidad",
          "PrecioPromedioBruto",
          "CostoTotal",
          "PrecioPromedioNeto",
          "MargenBruto",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "Marca",
          "Linea",
          "Cantidad",
          "EntregadoCantidad",
          "PendienteEntregarCantidad",
          "PrecioPromedioBruto",
          "CostoTotal",
          "PrecioPromedioNeto",
          "MargenBruto",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca) &&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo MP Agrupado`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo MP Agrupado",
          email: mailTo,
          fileName: "ReporteVentasArticulosMPAgrupado.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo MP Agrupado.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "Nombre", sortable: true },

    { name: "Vendido", field: "Cantidad", sortable: true },
    // { name: "Entregado Meli", field: "EntregadoCantidad", sortable: true },
    // { name: "Por Entregar Meli", field: "PendienteEntregarCantidad", sortable: true },
    { name: "Precio Prom Bruto", field: "PrecioPromedioBruto", sortable: true },
    { name: "Costos", field: "CostoTotal", sortable: true },
    { name: "Precio Prom Neto", field: "PrecioPromedioNeto", sortable: true },
    { name: "Margen Bruto", field: "MargenBruto", sortable: true },

  ];


  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
          comment.Nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.Cantidad.toString().includes(search) ||
          comment.PrecioPromedioBruto.toString().includes(search) ||
          comment.CostoTotal.toString().includes(search) ||
          comment.PrecioPromedioNeto.toString().includes(search) ||
          comment.MargenBruto.toString().includes(search)  
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.Marca.includes(selectedMarca)
      );
    }
    if (selectedUnidadNegocio) {
      computedComments = computedComments.filter((e) =>
        e.UnidadNegocio.includes(selectedUnidadNegocio)
      );
    }

    setTotalItems(computedComments.length);

    let cant = computedComments.map((c) => parseFloat(c.Cantidad));
    let Tcant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidad(Tcant);

// === PROMEDIOS PONDERADOS ===
  const avgPrecioPromedioBruto =
    Tcant > 0
      ? computedComments.reduce(
          (t, c) => t + (parseFloat(c.PrecioPromedioBruto) || 0) * (parseFloat(c.Cantidad) || 0),
          0
        ) / Tcant
      : 0;

  const avgCostoTotal =
    Tcant > 0
      ? computedComments.reduce(
          (t, c) => t + (parseFloat(c.CostoTotal) || 0) * (parseFloat(c.Cantidad) || 0),
          0
        ) / Tcant
      : 0;

  const avgPrecioPromedioNeto =
    Tcant > 0
      ? computedComments.reduce(
          (t, c) => t + (parseFloat(c.PrecioPromedioNeto) || 0) * (parseFloat(c.Cantidad) || 0),
          0
        ) / Tcant
      : 0;

  setAvgPrecioPromedioBruto(avgPrecioPromedioBruto);
  setAvgCostoTotal(avgCostoTotal);
  setAvgPrecioPromedioNeto(avgPrecioPromedioNeto);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "Cantidad" &&
      sorting.field != "EntregadoCantidad" &&
      sorting.field != "PendienteEntregarCantidad" &&
      sorting.field != "PrecioPromedioBruto" &&
      sorting.field != "CostoTotal" &&
      sorting.field != "PrecioPromedio" &&
      sorting.field != "MargenBruto" 

    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "Cantidad" ||
        sorting.field == "EntregadoCantidadMeli" ||
        sorting.field == "PendienteEntregarCantidad" ||
        sorting.field == "PrecioPromedioBruto" ||
        sorting.field == "CostoTotal" ||
        sorting.field == "PrecioPromedio" ||
        sorting.field == "MargenBruto" 

      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "Cantidad" ||
        sorting.field == "EntregadoCantidadMeli" ||
        sorting.field == "PendienteEntregarCantidad" ||
        sorting.field == "PrecioPromedioBruto" ||
        sorting.field == "CostoTotal" ||
        sorting.field == "PrecioPromedio" ||
        sorting.field == "MargenBruto" 
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMarca,
    selectedUnidadNegocio,
    selectedFechaInicio,
    selectedFechaFin,
  ]);
console.log("hola", totalTotalCantidad)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px 6px" }}>
            <h4 style={{ margin: 0, fontWeight: 700, color: "#1e3a8a" }}>📊 Reporte Ventas MP Agrupado</h4>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Button size="sm" href="/MenuVentas" className="btn btn-danger">← Regresar</Button>
              <Button size="sm" color="primary" onClick={excel}>Excel <i className="far fa-file-excel"></i></Button>
            </div>
          </div>

          {/* Filters */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Filtros</div>
            <Row>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Inicio</Label>
                <Input bsSize="sm" type="date" value={selectedFechaInicio} required onChange={(e) => { setSelectedFechaInicio(e.target.value); setFechaModificada(true); }} />
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Fin</Label>
                <Input bsSize="sm" type="date" value={selectedFechaFin} required onChange={(e) => { setSelectedFechaFin(e.target.value); setFechaModificada(true); }} />
              </Col>
              <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                <Button size="sm" onClick={BuscaInfo} color={fechaModificada ? "danger" : "info"}>Actualizar</Button>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Marca</Label>
                <Input bsSize="sm" type="select" value={selectedMarca} onChange={(e) => { setSelectedMarca(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todas</option>
                  {marcas.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => (
                    <option key={a._id} value={a.name}>{a.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Unidad Negocio</Label>
                <Input bsSize="sm" type="select" value={selectedUnidadNegocio} onChange={(e) => { setSelectedUnidadNegocio(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todas</option>
                  {unidadesNegocio.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => (
                    <option key={a._id} value={a.name}>{a.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label style={{ fontSize: "0.8rem" }}>Buscar</Label>
                <Search onSearch={(value) => { setSearch(value); setCurrentPage(1); }} />
              </Col>
            </Row>
          </div>

          {/* Pagination */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
            <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem" }}>
              {commentsData.length} artículos
            </span>
          </div>

          <div className="table-wrapper">
            <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
              <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order })} />
              <tbody>
                {commentsData.map((a, idx) => (
                  <tr key={idx}>
                    <td>{a.SKU}</td>
                    <td>{a.Nombre}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.Cantidad)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioBruto)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoTotal)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioNeto)}</td>
                    <td style={a.MargenBruto < 15 ? { backgroundColor: "#fee2e2" } : a.MargenBruto > 25 ? { backgroundColor: "#dcfce7" } : {}}>
                      {new Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(a.MargenBruto)} %
                    </td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700, background: "#f1f5f9" }}>
                  <td></td>
                  <td style={{ color: "#1e3a8a" }}>TOTAL</td>
                  <td>{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                  <td></td><td></td><td></td><td></td>
                </tr>
                <tr style={{ fontWeight: 700, background: "#f1f5f9" }}>
                  <td></td>
                  <td style={{ color: "#1e3a8a" }}>PROMEDIOS</td>
                  <td></td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(avgPrecioPromedioBruto)}</td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(avgCostoTotal)}</td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(avgPrecioPromedioNeto)}</td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ReporteVentasArticulosMPAgrupado;
